import styled from 'styled-components';

const ComboSlotOptionCardDetail = styled.div`
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  display: flex;
  flex: 9;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding: 0 0 0 1.25rem;
  text-align: left;
`;

export default ComboSlotOptionCardDetail;
